"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferDetailsGallery = void 0;
var OfferDetailsGallery_1 = require("./OfferDetailsGallery");
Object.defineProperty(exports, "OfferDetailsGallery", { enumerable: true, get: function () { return OfferDetailsGallery_1.OfferDetailsGallery; } });
